document.addEventListener('DOMContentLoaded', function () {
    /* -------------------- MyFlowers Club — Collection -------------------- */
    (function () {
        const SELECTOR = {
            carousel: '[data-mfc-carousel]',
            section: '.mfc-collection',
            swiper: '.swiper',
            nextBtn: '.mfc-collection__nav-next',
            prevBtn: '.mfc-collection__nav-prev',
            card: '.mfc-card',
            sizeInput: '.mfc-card__size-input',
            addBtn: '[data-mfc-add]',
            badge: '[data-mfc-badge]',
            total: '[data-mfc-total]'
        };

        const FALLBACK_MEMBERSHIP_ID = '53519511060808';
        // Module-wide in-flight guard: one submit at a time across ALL cards, so
        // two quick clicks can't fire overlapping clear/add sequences and race into
        // a cart with the wrong bouquet or a duplicated add-on.
        let isSubmitting = false;

        function formatMoney(cents) {
            return (cents / 100).toLocaleString('en-GB', {
                style: 'currency',
                currency: 'GBP'
            });
        }

        // "Today" anchored to Europe/London, stored at UTC noon so day math is DST-safe.
        function getLondonToday() {
            const parts = new Intl.DateTimeFormat('en-GB', {
                timeZone: 'Europe/London',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            }).formatToParts(new Date());

            const get = type => Number(parts.find(p => p.type === type).value);
            return new Date(Date.UTC(get('year'), get('month') - 1, get('day'), 12, 0, 0));
        }

        function addDays(date, days) {
            const next = new Date(date.getTime());
            next.setUTCDate(next.getUTCDate() + days);
            return next;
        }

        function toDeliveryDMY(date) {
            return date.toLocaleDateString('en-GB', { timeZone: 'UTC' });
        }

        // "Mon, 1 June" — matches the design badge format.
        function toBadgeLabel(date) {
            const weekday = date.toLocaleDateString('en-GB', { timeZone: 'UTC', weekday: 'short' });
            const month = date.toLocaleDateString('en-GB', { timeZone: 'UTC', month: 'long' });
            return weekday + ', ' + date.getUTCDate() + ' ' + month;
        }

        function applyDates(carousel) {
            const today = getLondonToday();
            carousel.querySelectorAll(SELECTOR.card).forEach(card => {
                const index = Number(card.dataset.mfcIndex) || 0;
                const delivery = addDays(today, index + 1);

                card.dataset.mfcDelivery = toDeliveryDMY(delivery);

                const badge = card.querySelector(SELECTOR.badge);
                if (badge) badge.textContent = toBadgeLabel(delivery);
            });
        }

        function recomputeTotal(card, membershipLabel) {
            const input = card.querySelector(SELECTOR.sizeInput + ':checked');
            const totalEl = card.querySelector(SELECTOR.total);
            if (!input || !totalEl) return;

            const price = Number(input.dataset.price);
            totalEl.textContent = membershipLabel + ' + ' + formatMoney(price) + ' bouquet';
        }

        async function handleAdd(card, membershipId) {
            if (isSubmitting || card.dataset.mfcBusy === '1') return;

            const input = card.querySelector(SELECTOR.sizeInput + ':checked');
            const btn = card.querySelector(SELECTOR.addBtn);
            if (!input) return;

            // Demo cards have no variant id — the button is a visual no-op there.
            const variantId = input.dataset.variantId;
            if (!variantId) return;

            // Recompute the delivery date at click time so a tab left open past
            // midnight can't submit a stale "tomorrow".
            const cardIndex = Number(card.dataset.mfcIndex) || 0;
            const deliveryDMY = toDeliveryDMY(addDays(getLondonToday(), cardIndex + 1));

            isSubmitting = true;
            card.dataset.mfcBusy = '1';
            if (btn) {
                btn.dataset.mfcLabel = btn.textContent;
                btn.textContent = 'Adding…';
                btn.disabled = true;
            }

            try {
                // Fresh session per order: wipe the cart first so it ends up with
                // exactly this bouquet + the membership add-on. Without this, going
                // "back" and ordering again stacks more bouquets into the same cart.
                const items = [
                    { id: Number(variantId), quantity: 1 },
                    { id: Number(membershipId), quantity: 1 }
                ];
                // Общая очередь CartService (cart-service.js подключён всегда):
                // безусловный сброс → один add.js с обеими строками + delivery_date.
                // Раньше — clear.js → add.js → update.js сырыми fetch мимо очереди.
                await window.CartService.prepareCheckout({
                    items: items.map(item => ({ variantId: item.id, quantity: item.quantity })),
                    attributes: { delivery_date: deliveryDMY },
                    clear: true,
                    // клубный заказ: в чекаут уходят ровно букет и членство
                    exclusive: true
                });

                window.location.href = '/checkout';
            } catch (err) {
                console.error('MyFlowers Club: add to cart failed', err);
                isSubmitting = false;
                card.dataset.mfcBusy = '';
                if (btn) {
                    btn.disabled = false;
                    btn.textContent = btn.dataset.mfcLabel || 'Join & order this bouquet';
                }
            }
        }

        function initCarousel(carousel) {
            const membershipId = carousel.dataset.mfcMembershipVariantId || FALLBACK_MEMBERSHIP_ID;
            const membershipLabel = carousel.dataset.mfcMembershipLabel || '';

            applyDates(carousel);

            carousel.querySelectorAll(SELECTOR.card).forEach(card => {
                recomputeTotal(card, membershipLabel);
            });

            carousel.addEventListener('change', function (e) {
                const input = e.target.closest(SELECTOR.sizeInput);
                if (!input) return;
                const card = input.closest(SELECTOR.card);
                if (card) recomputeTotal(card, membershipLabel);
            });

            carousel.addEventListener('click', function (e) {
                const btn = e.target.closest(SELECTOR.addBtn);
                if (!btn) return;
                const card = btn.closest(SELECTOR.card);
                if (card) handleAdd(card, membershipId);
            });

            // Nav arrows live in the section head, outside the carousel wrapper.
            const sectionEl = carousel.closest(SELECTOR.section) || carousel;
            const swiperEl = carousel.querySelector(SELECTOR.swiper);
            if (swiperEl && typeof Swiper !== 'undefined') {
                new Swiper(swiperEl, {
                    slidesPerView: 'auto',
                    spaceBetween: 13,
                    slidesOffsetAfter: 16,
                    navigation: {
                        nextEl: sectionEl.querySelector(SELECTOR.nextBtn),
                        prevEl: sectionEl.querySelector(SELECTOR.prevBtn)
                    }
                });
            }
        }

        document.querySelectorAll(SELECTOR.carousel).forEach(initCarousel);

        // When the user hits "Back" from checkout the page is restored from the
        // back/forward cache with the DOM frozen mid-submit — button stuck on
        // "Adding…" and the guards still latched. Reset everything on restore.
        window.addEventListener('pageshow', function (e) {
            if (!e.persisted) return;
            isSubmitting = false;
            document.querySelectorAll(SELECTOR.card).forEach(card => {
                card.dataset.mfcBusy = '';
                const btn = card.querySelector(SELECTOR.addBtn);
                if (btn && btn.dataset.mfcLabel) {
                    btn.disabled = false;
                    btn.textContent = btn.dataset.mfcLabel;
                }
            });
        });
    })();
});
